import { lazyLoad } from 'utils/loadable';

/**
 *
 * Asynchronously loads the component for CreatePasswordPage
 *
 */

const CreatePasswordPage = lazyLoad(
  () => import('app/modules/Auth/CreatePassword'),
  (module) => module.default,
);

export default CreatePasswordPage;
